// Updated requestimateForm.jsx with shared pricing calculations
import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import moment from 'moment';
import SpecialistForm from './../../newSpecialistForm';
import VehicleForm from './../../vehicleSelection';
import ServiceForm from './../../newServiceForm';
import NotesForm from './../../notesForm';
import DatesForm from './../../datesForm';
import { HTTPService } from "./../../../services/httpService";
import { convertToUTC } from '../../../util/convert_timezone';
import { isAllDealerships } from '../../../util/locationUtils';
import ReactGA from 'react-ga4';

// UPDATED: Import shared pricing module instead of old serviceUtils
import { 
  SharedRequestPricing, 
  SharedPricingUtils 
} from './../services/sharedPricingCalculations';

const API = new HTTPService();

class RequestimateForm extends Component {

  constructor(props) {
    super(props);

    this.state = {
      redirect: false,
      currentStep: 1,
      // REMOVED: hardcoded platformFee - will use shared config
      customer: this.props.typeId,
      category : "Paint",
      vehicleID: '',
      services: [],
      total : 0,
      discount : 0,  // UPDATED: Now properly tracks discounts
      taxRate : 0,
      duration : 0,
      fee : 0,
      loading:false,
      notes:"",
      availableDate: new moment().startOf('day'),
      dueDate: new moment().startOf('day'),
      newVehicleId: {},
      newRequestId: {},
      user: this.props.user,
      companyName: this.props.companyName,
      company: this.props.company,
      specialist : "",
      specialists :[],
      stockNumber: "",
      dealNumber: "",
      dealerContact: this.props.typeId  // Default to the user creating the request
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSpecialistCategory = this.handleSpecialistCategory.bind(this);
    this.handleSpecialist = this.handleSpecialist.bind(this);
    this.handleServices = this.handleServices.bind(this);
    this.handleVIN = this.handleVIN.bind(this);
    this.handleNotes = this.handleNotes.bind(this);
    this.handleDueDate = this.handleDueDate.bind(this);
    this.handleAvailableDate = this.handleAvailableDate.bind(this);
    this._next = this._next.bind(this);
    this._prev = this._prev.bind(this);
    this.handleStockNumberChange = this.handleStockNumberChange.bind(this);
    this.handleDealNumberChange = this.handleDealNumberChange.bind(this);
    this.handleContactChange = this.handleContactChange.bind(this);
  }

  handleSubmit = async e => {
    e.preventDefault();
    this.setState({ loading: true });

    try {
      console.log("Starting job creation with services:", this.state.services);

      // Validate services before proceeding
      const validationResult = SharedPricingUtils.validatePricingData(this.state.services);
      if (!validationResult.isValid) {
        throw new Error(`Pricing validation failed: ${validationResult.errors.join(', ')}`);
      }

      // Get complete pricing breakdown using shared module
      const pricingBreakdown = SharedRequestPricing.getCompletePricingBreakdown(this.state.services, {
        jobType: "dealer",  // This is a dealer job
        taxRate: 0          // Dealers don't pay taxes
      });

      console.log("Pricing breakdown for dealer job:", pricingBreakdown);

      // Add vehicle to the vehicle table
      await this.addVehicle();

      // Add the request to the request table with calculated pricing
      const newRequest = await this.addRequest(pricingBreakdown);

      // Add the requestState record
      await this.addRequestState(newRequest, "created", null);

      // Add the notes
      await this.addNote(newRequest);

      // Add the services records with calculated pricing
      await this.addServices(newRequest, pricingBreakdown);

      // Handle specialist notifications (discovery and assigned)
      const findInstaller = await this.findInstallers(newRequest);
      console.log("requestimateForm : found installers :", findInstaller);
      
      this.setState({ loading: false });

      // Redirect based on contract requirements
      if (this.props.company.customer_contract === "N"){
        alert("We'll take it from here") 
        ReactGA.event({category: 'Dealer', action: 'Created Request', label: 'prod'});
        window.location = "/requestimates";  
      } else {
        alert("Let's create the customer contract") 
        ReactGA.event({category: 'Dealer', action: 'Created Request', label: 'prod'});
        window.location = "/contract/"+newRequest;  
      }
      
    } catch (error) {
      console.error("Error creating job:", error);
      this.setState({ loading: false });
      alert("Error creating job: " + error.message);
    }
  };
    
  // Use the submitted data to set the state
  handleChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value
    })
  }

  sendMessage = async (data)  => {
    console.log ("Sending SMS :", data);
    await API.post("/messages/push", data);
    return;
  }

  handleCancel = e => {
    e.preventDefault();
    ReactGA.event({category: 'Dealer', action: 'Cancel Creating Request', label: 'prod'});
    this.props.history.push("/requestimates");
    return;
  }

  addDays(date, days) {
    let result = moment(date).format("YYYY-MM-DD");
    let results = moment(result).add(days, "days");
    return results;
  }

  handleNotes(notes) {
    this.setState({notes})
  }

  // UPDATED: Use shared pricing calculations
  handleServices(services, total, discount) {
    console.log("handleServices called with:", { services, total, discount });
    
    // Validate the totals using shared pricing module
    const calculatedTotal = SharedRequestPricing.calculateRequestTotal(services);
    const calculatedDiscount = SharedRequestPricing.calculateRequestDiscount(services);
    const calculatedDuration = SharedRequestPricing.calculateTotalDuration(services);
    
    // Log comparison for debugging
    if (Math.abs(total - calculatedTotal) > 0.01 || Math.abs(discount - calculatedDiscount) > 0.01) {
      console.warn("Total mismatch detected:", {
        passedTotal: total,
        calculatedTotal: calculatedTotal,
        passedDiscount: discount,
        calculatedDiscount: calculatedDiscount
      });
    }
    
    // Calculate due date based on duration
    let diff = Math.max(1, Math.round(calculatedDuration));
    let dueDate = this.addDays(this.state.availableDate, diff).toDate();

    // Use calculated values for consistency
    this.setState({
      services, 
      total: calculatedTotal,      // Use shared calculation
      discount: calculatedDiscount, // Use shared calculation
      duration: calculatedDuration, // Use shared calculation
      dueDate
    });
  }

  handleSpecialist(specialist, category, locationId) {
    this.setState({ specialist, specialistLocationId: locationId || null })
  }

  handleSpecialistCategory(category) {
    console.log ("requestimateForm : handle category ", category)
    this.setState({ category })
  }
 
  handleStockNumberChange(stockNumber) {
    this.setState({ stockNumber: stockNumber || "" });
  }

  handleDealNumberChange(dealNumber) {
    this.setState({ dealNumber: dealNumber || "" });
  }

  handleContactChange(contactId) {
    this.setState({ dealerContact: contactId });
  }

  handleVIN(vehicle) {
    console.log ("Update vehicle state", vehicle)
    this.setState({ vehicle })
  }

  handleDueDate(date) {
    this.setState({ dueDate: date })
  }

  handleAvailableDate(date) {
    let diff = Math.max(1, Math.round(this.state.duration));
    let dueDate = this.addDays(date, diff).toDate();
    this.setState({availableDate: date, dueDate})
  }

  // Vehicle handling (unchanged)
  addVehicle = async () => {
    const { vehicle } = this.state;

    if (!vehicle.vin) {
      console.error('VIN is required');
      return null;
    }

    const formattedVin = vehicle.vin.trim().toUpperCase();
    
    const formattedVehicle = {
      ...vehicle,
      vin: formattedVin
    };

    this.setState({ 
      vehicle: formattedVehicle 
    });

    try {
      const { data: existingVehicle } = await API.get(`/vehicles/${formattedVin}`);

      let newVehicleId;

      if (!existingVehicle || existingVehicle.length === 0) {
        const { data: createdVehicleId } = await API.post(`/vehicles`, formattedVehicle);
        newVehicleId = createdVehicleId;
      } else {
        newVehicleId = existingVehicle.id || existingVehicle[0]?.id;
      }

      this.setState({ newVehicleId });
      return newVehicleId;
      
    } catch (error) {
      console.error('Error processing vehicle:', error);
      return null;
    }
  };

  findInstallers = async (requestId) => {
    let find = "";
    if (this.state.specialist === "0") {
      find = "/matchAll/?Id="
    } else {
      find = "/matchA/?Id="
    }
    const { data : matchInstallers } = await API.get(find + requestId)
    return matchInstallers;
  }

  getInstallers = async (requestId) => {
    let responseRequest = `/requestoffered/request/${requestId}`;
    const { data: tempRequestOffers } = await API.get(responseRequest);
    return tempRequestOffers;
  }

  sendRequestEmail = async (requestId) => {
    let responseRequest = `/sendemailreq/${requestId}`;
    const { data: tempRequestOffers } = await API.get(responseRequest);
    return tempRequestOffers;
  }

  addRequestState = async (requestId, requeststate, requestService) => {
    const state = {
      requestId: requestId,
      stateDate: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      requestStatus: requeststate,
      serviceId: requestService,
      changedByUserId: this.props.user.User_id,
      changedByUserType: this.props.userType
    };

    const apiEndpoint = `/requestState`;
    await API.post(apiEndpoint, state);
    return null;
  };

  addNote = async (requestId) => {
    let newNote = {
      requestId : await requestId,
      noteDate : convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      noteText : this.state.notes,
      userType : this.props.userType,
      userId : this.props.typeId
    }
    if (!this.state.notes){
      Promise.resolve(this.addNote)
      return;
    }
    const { data : newRequestNote } = await API.post("/requestnotes/", newNote)
    console.log ( newRequestNote);
    return newRequestNote;
  };

  // UPDATED: Use shared pricing calculations for request creation
  addRequest = async (pricingBreakdown) => {
    let newRequest = {
      requestType: this.props.userType,
      requestor: this.state.company.dealer_id,
      serviceRequested: this.state.services[0].service_category + " - " + this.state.services[0].description,
      // UPDATED: Use calculated values from pricing breakdown
      requestTotal: pricingBreakdown.originalTotal,      // Original total (before discounts)
      requestDiscount: pricingBreakdown.totalDiscount,   // Total discount amount
      requestFee: pricingBreakdown.platformFee,          // NEW: Post-discount fee
      requestDuration: pricingBreakdown.totalDuration,   // Total duration
      requestTaxes: pricingBreakdown.taxes,              // Tax amount (0 for dealers)
      assignedTo: this.state.specialist,
      createdBy: this.props.typeId,
      availableDate: convertToUTC(this.state.availableDate).format("YYYY-MM-DD HH:mm:ss"),
      dueDate: convertToUTC(this.state.dueDate).format("YYYY-MM-DD HH:mm:ss"),
      currentState: "new",
      createdDate: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      vin: this.state.vehicle.vin,
      createdType: "dealer",
      installerCatalog: this.state.specialist,
      stock_number: this.props.userType === "dealer" ? this.state.stockNumber : null,
      deal_number: this.props.userType === "dealer" ? this.state.dealNumber : null,
      dealer_contact: this.props.userType === "dealer" ? this.state.dealerContact : null,
      location_id: this.state.specialistLocationId || this.props.selectedLocationId || null
    }
    
    // Process the services requested array to create the right value
    if (this.state.services.length > 1) {
      newRequest.serviceRequested = newRequest.serviceRequested + " + " + (this.state.services.length - 1);
    }
    
    const { data: newRequestId } = await API.post("/requestimates/", newRequest);
    this.setState({ newRequestId });
    return newRequestId;
  }

  // UPDATED: Use shared pricing calculations for services
  addServices = async (requestId, pricingBreakdown) => {
    console.log("Services being saved:", this.state.services);
    console.log("Pricing breakdown:", pricingBreakdown);
    
    // Prepare services using shared pricing module
    const submissionData = SharedPricingUtils.prepareForSubmission(this.state.services, {
      jobType: "dealer",
      taxRate: 0
    });
    
    const newRequestService = {
      requestId: await requestId,
      serviceId: "",
      serviceAmount: 0,
      serviceValue: 0,         // NEW: Final amount after discount
      serviceDiscount: 0,
      serviceDuration: 0,
      serviceFee: 0,           // NEW: Service-level fee
      serviceState: "new",
      serviceDate: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      customDescription: "",
      retailPrice: 0,
      recommendedProductId: null,  // Product recommendation for technician
      serviceQuantity: 1,
      unitPrice: 0
    }

    for (let i = 0; i < submissionData.services.length; i++) {
      const service = submissionData.services[i];

      // UPDATED: Use calculated values from shared pricing module
      newRequestService.serviceId = service.service_id;
      newRequestService.serviceAmount = service.service_amount;     // Original amount
      newRequestService.serviceValue = service.service_value;       // Final amount after discount
      newRequestService.serviceDiscount = service.service_discount; // Discount amount
      newRequestService.serviceDuration = service.service_duration; // Duration
      newRequestService.serviceFee = service.service_fee;           // Service-level fee (post-discount)
      newRequestService.customDescription = service.custom_description || service.description;
      newRequestService.retailPrice = service.retail_price || null;
      newRequestService.recommendedProductId = service.recommended_product_id || null;
      newRequestService.serviceQuantity = service.quantity || 1;
      newRequestService.unitPrice = service.unit_price || service.service_amount;

      console.log(`Service ${i + 1}:`, {
        serviceId: service.service_id,
        description: service.description,
        serviceAmount: service.service_amount,
        serviceValue: service.service_value,
        serviceDiscount: service.service_discount,
        serviceFee: service.service_fee,
        retailPrice: service.retail_price,
        quantity: service.quantity,
        unitPrice: service.unit_price
      });

      await API.post("/requestService", newRequestService);
    }
    return null;
  }
  
  // Navigation methods (unchanged)
  _next() {
    let currentStep = this.state.currentStep
    currentStep = currentStep >= 4 ? 5 : currentStep + 1
    this.setState({ currentStep: currentStep })
  }

  _prev() {
    let currentStep = this.state.currentStep
    currentStep = currentStep <= 1 ? 1 : currentStep - 1
    this.setState({ currentStep: currentStep })
  }

  // Navigation buttons (unchanged)
  get previousButton() {
    let currentStep = this.state.currentStep;
    if (currentStep !== 1) {
      return (<button className="jv-btn jv-btn-tertiary" type="button" onClick={this._prev}>Previous</button>)
    }
    return null;
  }

  get nextButton() {
    let currentStep = this.state.currentStep;
    if(currentStep < 5){
      let disabled = true;
      if (currentStep === 1 && this.state.specialist) {
        disabled = false;
      }
      if (currentStep === 2 && this.state.vehicle) {
        disabled = false;
      }
      if (currentStep === 3 && this.state.services.length > 0) {
        disabled = false;
      }
      if (currentStep === 4) {
        disabled = false;
      }
      return (
        <button
          className="jv-btn jv-btn-primary float-right"
          type="button" disabled={disabled} onClick={this._next}>
        Next
        </button>        
      )
    } else {
      return (
        <button
          className="jv-btn jv-btn-primary float-right"
          type="button" onClick={this.handleSubmit}>
          {this.state.loading && <span>
            <i className="fa-sharp fa-regular fa-spinner fa-spin" />
          </span>}
          {!this.state.loading && <span>Send Request</span>}
        </button>        
      ) 
    }
  };

  // Step indicators (unchanged)
  get steepOne () {
    if (!this.state.specialist) {
      return (
        <li className="nav-item">
          <div className="col-sm-12 p-0">
            <button className="btn btn-outline-secondary btn-circle bg-white">
            </button>
            <br />
            Specialist
            <div className="line-50-right"></div>
          </div>
        </li>
      );
    }
    return (
      <li className="nav-item">
        <div className="col-sm-12 p-0">
          <button className="btn btn-outline-success btn-circle bg-white">
            <i className="fa-sharp fa-regular fa-check"></i>
          </button>
          <br />
          Specialist
          <div className="line-50-right"></div>
        </div>
      </li>
    );
  };

  get steepTwo () {
    if (!this.state.vehicle) {
      return (
        <li className="nav-item">
          <div className="col-sm-12 p-0">
            <button className="btn btn-outline-secondary btn-circle bg-white">
            </button>
            <br />
            Vehicle
            <div className="line-100"></div>
          </div>
        </li>
      );
    }
    return (
      <li className="nav-item">
        <div className="col-sm-12 p-0">
          <button className="btn btn-outline-success btn-circle bg-white">
            <i className="fa-sharp fa-regular fa-check"></i>
          </button>
          <br />
          Vehicle
          <div className="line-100"></div>
        </div>
      </li>
    );
  };

  get steepThree () {
    if (this.state.services < 1) {
      return (
        <li className="nav-item">
          <div className="col-sm-12 p-0">
            <button className="btn btn-outline-secondary btn-circle bg-white"></button>
            <br />
            Work
            <div className="line-100"></div>
          </div>
        </li>
      );
    }
    return (
      <li className="nav-item">
        <div className="col-sm-12 p-0">
          <button className="btn btn-outline-success btn-circle bg-white">
            <i className="fa-sharp fa-regular fa-check"></i>
          </button>
          <br />
          Work
          <div className="line-100"></div>
        </div>
      </li>
    );
  };

  get steepFour () {
    if (!this.state.notes) {
      return (
        <li className="nav-item">
          <div className="col-sm-12 p-0">
            <button className="btn btn-outline-secondary btn-circle bg-white"></button>
            <br />
            Notes
            <div className="line-100"></div>
          </div>
        </li>
      );
    }
    return (
      <li className="nav-item">
        <div className="col-sm-12 p-0">
          <button className="btn btn-outline-success btn-circle bg-white">
            <i className="fa-sharp fa-regular fa-check"></i>
          </button>
          <br />
          Notes
          <div className="line-100"></div>
        </div>
      </li>
    );
  };

  get steepFive () {
    if (this.state.currentStep !== 5 && this.state.dueDate) {
      return (
        <li className="nav-item">
          <div className="col-sm-12 p-0">
            <button className="btn btn-outline-secondary btn-circle bg-white"></button>
            <br />
            Dates
            <div className="line-50-left"></div>
          </div>
        </li>
      );
    }
    return (
      <li className="nav-item">
        <div className="col-sm-12 p-0">
          <button className="btn btn-outline-success btn-circle bg-white">
            <i className="fa-sharp fa-regular fa-check"></i>
          </button>
          <br />
          Dates
          <div className="line-50-left"></div>
        </div>
      </li>
    );
  };

  render() {
    // Dealer-group users can switch the active dealership via CompanyLocationSelector.
    // typeId is pinned to the home dealership (company.dealer_id), so prefer the
    // currently-selected dealership for specialist lookups; fall back to typeId when
    // "All Dealerships" (or none) is selected.
    const effectiveDealerId = isAllDealerships(this.props.selectedDealerId)
      ? this.props.typeId
      : this.props.selectedDealerId;

    return (
      <React.Fragment>
        <div className="bg-white border border-secondary">
          <div className="col-lg-12 text-right">
            <button className="btn" type="button" onClick={this.handleCancel}>
              <i className="fa-sharp fa-regular fa-times"></i>
            </button>
          </div>

          <div className="col-lg-12 d-flex justify-content-center">
            <ul className="col-lg-5 nav nav-pills nav-fill text-center">
              {this.steepOne}
              {this.steepTwo}
              {this.steepThree}
              {this.steepFour}
              {this.steepFive}
            </ul>
          </div>
          <br />
          <br />
          <br />
          <div className="col-lg-12 p-0">
            
          <SpecialistForm
              currentStep={this.state.currentStep}
              selectedSpecialist = {this.state.specialist}
              dealerId = {effectiveDealerId}
              userType={this.props.userType}
              userAccess={this.props.userAccess}
              handleSpecialist={this.handleSpecialist}
              handleSpecialistCategory={this.handleSpecialistCategory}
              specialists={this.state.specialists} />

            <VehicleForm
              currentStep={this.state.currentStep}
              handleVIN={this.handleVIN}
              notes = {this.state.notes}
              default={this.props.company.main_make}
              userType= {"dealer"}
              customerType={"whole"}
              vehicle={this.state.vehicle}
              onStockNumberChange={this.handleStockNumberChange}
            />

            <ServiceForm
                userType={this.props.userType}
                typeId={this.props.typeId}
                currentStep={this.state.currentStep} 
                handleServices={this.handleServices}
                specialist = {this.state.specialist}
                vehicle={this.state.vehicle}
                total={this.state.total}
                discount={this.state.discount}
                services={this.state.services}
                category={this.state.category}
                notes = {this.state.notes}
                customerType={"WHOLE"}  // Added for dealer jobs
                />
              <NotesForm
                currentStep={this.state.currentStep}
                vehicle={this.state.vehicle}
                userType = "dealer"
                requestType = "dealer"
                typeId = {effectiveDealerId}
                dealerId = {effectiveDealerId}
                availableDate = {this.state.availableDate}
                dueDate = {this.state.dueDate}
                services={this.state.services}
                notes = {this.state.notes}
                handleNotes={this.handleNotes}
                onDealNumberChange={this.handleDealNumberChange}
                handleContactChange={this.handleContactChange}
                dealerContact={this.state.dealerContact}
                />       
            <DatesForm
              userType={this.props.userType}
              currentStep={this.state.currentStep}
              handleAvailableDate={this.handleAvailableDate}
              handleDueDate={this.handleDueDate}
              availableDate={this.state.availableDate}
              dueDate={this.state.dueDate}
              duration={this.state.duration}
              vehicle={this.state.vehicle}
              notes={this.state.notes}
              services={this.state.services}
              specialist={this.state.specialist}
              currentLocation={this.props.currentLocation}
            />

            <div className="m-5 d-flex justify-content-center">
              <div className="p-2">
                {this.previousButton}
              </div>
              <div className="p-2">
                {this.nextButton}
              </div>
            </div>

          </div>
        </div>
      </React.Fragment>
    );
  };
}
export default withRouter(RequestimateForm);